// extracted by mini-css-extract-plugin
export var videoHero = "_ax-4";
export var videoHeroImage = "_ax-5";
export var videoHeroOverlay = "_ax-6";
export var videoHeroSubtitle = "_ax-8";
export var videoHeroText = "_ax-7";
export var videoLauncher = "_ax-0";
export var videoLauncherIcon = "_ax-1";
export var videoLauncherSubtitle = "_ax-3";
export var videoLauncherTitle = "_ax-2";
export var videoPlayer = "_ax-a";
export var videoPlayerWrap = "_ax-9";